/* eslint-disable no-process-env */

export const num = (val: any) => (val == null ? val : Number.parseInt(val, 10));
export const bool = (val: any) => (val == null ? val : val.toString() === 'true');

export default {
  REACT_APP_ENVIRONMENT: {
    value: process.env.NODE_ENV,
    defaultValue: 'development',
  },
  REACT_APP_API_ENVIRONMENT: {
    value: process.env.REACT_APP_API_ENVIRONMENT,
    defaultValue: 'staging',
  },
  REACT_APP_AUTH_CLIENT_ID: {
    value: process.env.REACT_APP_AUTH_CLIENT_ID,
  },
  REACT_APP_AUTH_CLIENT_SECRET: {
    value: process.env.REACT_APP_AUTH_CLIENT_SECRET,
  },
  REACT_APP_AUTH_URL: {
    value: process.env.REACT_APP_AUTH_URL,
  },
  REACT_APP_COGNITO_EXCHANGE_URL: {
    value: process.env.REACT_APP_COGNITO_EXCHANGE_URL,
  },
  REACT_APP_HYROX_API_URL: {
    value: process.env.REACT_APP_HYROX_API_URL,
  },
  REACT_APP_PASSWORD_URL: {
    value: process.env.REACT_APP_PASSWORD_URL,
  },
  REACT_APP_FEEDBACK_URL: {
    value: process.env.REACT_APP_FEEDBACK_URL,
  },
  REACT_APP_LOCALISATION_ENABLED: {
    value: process.env.REACT_APP_LOCALISATION_ENABLED,
    format: bool,
  },
  REACT_APP_WHITEBOARD_ENABLED: {
    value: process.env.REACT_APP_WHITEBOARD_ENABLED,
    format: bool,
  },
  REACT_APP_WORKOUT_FEEDBACK_ENABLED: {
    value: process.env.REACT_APP_WORKOUT_FEEDBACK_ENABLED,
    format: bool,
  },
  REACT_APP_RESOURCE_LISTS_ENABLED: {
    value: process.env.REACT_APP_RESOURCE_LISTS_ENABLED,
    format: bool,
  },
  REACT_APP_SENTRY_DSN: {
    value: process.env.REACT_APP_SENTRY_DSN,
  },
  REACT_APP_SENTRY_ENVIRONMENT: {
    value: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  },
  REACT_APP_SSO_ENABLED: {
    value: process.env.REACT_APP_SSO_ENABLED,
    format: bool,
  },
  REACT_APP_SSO_REDIRECT_URL: {
    value: process.env.REACT_APP_SSO_REDIRECT_URL,
  },
  REACT_APP_BANNER_LINK_URL: {
    value: process.env.REACT_APP_BANNER_LINK_URL,
  },
  REACT_APP_BANNER_IMAGE_URL: {
    value: process.env.REACT_APP_BANNER_IMAGE_URL,
  },
  REACT_APP_MOBILE_BANNER_IMAGE_URL: {
    value: process.env.REACT_APP_MOBILE_BANNER_IMAGE_URL,
  },
  REACT_APP_ROOT_RESOURCE_LIST_ID: {
    value: process.env.REACT_APP_ROOT_RESOURCE_LIST_ID,
  },
  REACT_APP_ROOT_COLLECTION_LIST_ID: {
    value: process.env.REACT_APP_ROOT_COLLECTION_LIST_ID,
  },
  REACT_APP_NEW_LIBRARY_ENABLED: {
    value: process.env.REACT_APP_NEW_LIBRARY_ENABLED,
    format: bool,
  },
  REACT_APP_AMPLITUDE_API_KEY: {
    value: process.env.REACT_APP_AMPLITUDE_API_KEY,
  },
  REACT_APP_THAI_ENABLED: {
    value: process.env.REACT_APP_THAI_ENABLED,
    format: bool,
  },
  REACT_APP_SUBTITLES_ENABLED: {
    value: process.env.REACT_APP_SUBTITLES_ENABLED,
    format: bool,
  },
  REACT_APP_PERSONALISED_HOMESCREEN_ENABLED: {
    value: process.env.REACT_APP_PERSONALISED_HOMESCREEN_ENABLED,
    format: bool,
  },
  REACT_APP_TOKEN_VERIFICATION_URI: {
    value: process.env.REACT_APP_TOKEN_VERIFICATION_URI,
  },
  REACT_APP_TOKEN_INTROSPECT_URL: {
    value: process.env.REACT_APP_TOKEN_INTROSPECT_URL,
  },
  REACT_APP_ONE_FIIT_CLIENT_ID: {
    value: process.env.REACT_APP_ONE_FIIT_CLIENT_ID,
  },
  REACT_APP_AUTH_CODE_URL: {
    value: process.env.REACT_APP_AUTH_CODE_URL,
  },
  REACT_APP_AUTH_CODE_NO_REDIRECT_URL: {
    value: process.env.REACT_APP_AUTH_CODE_NO_REDIRECT_URL,
  },
  REACT_APP_AUTH_CALLBACK_REDIRECT_URL: {
    value: process.env.REACT_APP_AUTH_CALLBACK_REDIRECT_URL,
  },
  REACT_APP_HYROX_CLIENT_ID_FOR_ONE_FIIT: {
    value: process.env.REACT_APP_HYROX_CLIENT_ID_FOR_ONE_FIIT,
  },
  REACT_APP_WORKOUT_BUILDER_URL: {
    value: process.env.REACT_APP_WORKOUT_BUILDER_URL,
  },
  REACT_APP_CLIENT_ID_FOR_ONE_FIIT: {
    value: process.env.REACT_APP_CLIENT_ID_FOR_ONE_FIIT,
  },
  REACT_APP_WHITEBOARD_URL: {
    value: process.env.REACT_APP_WHITEBOARD_URL,
  },
  REACT_APP_PROGRESSIVE_PLANS_ENABLED: {
    value: process.env.REACT_APP_PROGRESSIVE_PLANS_ENABLED,
    format: bool,
  },
  REACT_APP_WORKOUTS_HOMEPAGE_ENABLED: {
    value: process.env.REACT_APP_WORKOUTS_HOMEPAGE_ENABLED,
    format: bool,
  },
  REACT_APP_GYM_FINDER_LEADS_ENABLED: {
    value: process.env.REACT_APP_GYM_FINDER_LEADS_ENABLED,
    format: bool,
  },
  REACT_APP_ACADEMY_URL: {
    value: process.env.REACT_APP_ACADEMY_URL,
    defaultValue: 'https://www.hyrox365.com/academy',
  },
  REACT_APP_RECORD_RELAY_URL: {
    value: process.env.REACT_APP_RECORD_RELAY_URL,
  },
  REACT_APP_RECORD_RELAY_API_KEY: {
    value: process.env.REACT_APP_RECORD_RELAY_API_KEY,
  },
};
